function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg163SolomonIslands(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#496E2D"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#0052B4"
    },
    points: "0,512 0,0 512,0 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "0,466.745 0,512 45.255,512 512,45.255 512,0 466.745,0 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "64.531,35.184 72.211,58.819 97.062,58.819 76.956,73.425 84.636,97.062 64.531,82.453    44.425,97.062 52.105,73.425 32,58.819 56.851,58.819  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "191.469,35.184 199.149,58.819 224,58.819 203.894,73.425 211.575,97.062 191.469,82.453    171.364,97.062 179.044,73.425 158.938,58.819 183.789,58.819  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "64.531,158.938 72.211,182.573 97.062,182.573 76.956,197.179 84.636,220.816    64.531,206.207 44.425,220.816 52.105,197.179 32,182.573 56.851,182.573  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "191.469,158.938 199.149,182.573 224,182.573 203.894,197.179 211.575,220.816    191.469,206.207 171.364,220.816 179.044,197.179 158.938,182.573 183.789,182.573  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "128,97.062 135.68,120.696 160.531,120.696 140.425,135.303 148.106,158.938 128,144.331    107.895,158.938 115.575,135.303 95.469,120.696 120.32,120.696  "
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg163SolomonIslands);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };